import {
  SIGNIN_USER_START, SIGNIN_USER_SUCCESS, SIGNIN_USER_ERROR, HIDE_SIGNIN_USER_ERROR,
  SIGNOUT_USER_SUCCESS, USER_DATA, AUTH_REFRESH_START, AUTH_REFRESH_SUCCESS, AUTH_REFRESH_ERROR, SIGNOUT_USER_START,
  FETCH_USER_ALLOWED_RIS_WITH_MIPS_SUCCESS,
  FETCH_USER_ALLOWED_RIS_WITH_MIPS_ERROR,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_START,
  VERIFY_OTP_ERROR,
  SET_SESSION_ROLE_SUCCESS,
  SET_DEFAULT_CONFIGURATIONS,
  UPDATE_USER_OTP_VERIFICATION,
  UPDATE_USER_IS_AUTHENTICATOR
} from "../../appRedux/actions/Auth.js";
import { getUserSessionData, GET_USER_SESSION_DATA, setUserSessionData, SET_USER_SESSION_DATA_BY_KEY } from "../actions/userLocalStorageSession.js";

const INIT_STATE = {
  appLoading: true,
  loading: false,
  submitting: false,
  message: '',
  error: '',
  authUser: JSON.parse(sessionStorage.getItem('user')),
  sessionData: {},
  configurations: null
};

export default (state = INIT_STATE, action) => {
  let newAuthUser;
  switch (action.type) {
    case SET_DEFAULT_CONFIGURATIONS:{
      return { ...state, configurations: action.configurations };
    }
    case AUTH_REFRESH_START: {
      return { ...state, appLoading: true };
    }
    case AUTH_REFRESH_SUCCESS: {
      return { ...state, appLoading: false };
    }
    case AUTH_REFRESH_ERROR: {
      return { ...state, appLoading: false };
    }
    case SIGNIN_USER_START: {
      return { ...state, error: '', message: '', loading: true };
    }
    case SIGNIN_USER_SUCCESS: {
      return { ...state, error: '', message: '', loading: false };
    }
    case SIGNIN_USER_ERROR: {
      return { ...state, error: '', message: action.payload, loading: false };
    }
    case VERIFY_OTP_START: {
      return {
        ...state,
        submitting: true
      }
    }
    case VERIFY_OTP_SUCCESS: {
      newAuthUser = { ...state.authUser }
      newAuthUser.authenticated = true;
      sessionStorage.setItem('user', JSON.stringify(newAuthUser));
      return {
        ...state,
        submitting: false,
        authUser: { ...newAuthUser }
      }
    }
    case VERIFY_OTP_ERROR: {
      return {
        ...state,
        submitting: false
      }
    }
    case HIDE_SIGNIN_USER_ERROR: {
      return { ...state, error: '', message: '' };
    }
    case SIGNOUT_USER_START: {
      return {
        ...state,
        appLoading: true,
      }
    }
    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        appLoading: false,
        authUser: null,
      }
    }
    case USER_DATA: {
      const sessionData = getUserSessionData(action.payload.email);
      if (!sessionData) {
        setUserSessionData(action.payload.email, {});
      }
      return {
        ...state,
        authUser: action.payload,
        sessionData: sessionData || {}
      };
    }
    case SET_SESSION_ROLE_SUCCESS: {
      newAuthUser = { ...state.authUser }
      newAuthUser.role = action.role;
      sessionStorage.setItem('user', JSON.stringify(newAuthUser));
      return {
        ...state,
        authUser: { ...newAuthUser }
      }
    }
    case GET_USER_SESSION_DATA: {
      const sessionData = getUserSessionData(action.email);
      if (!sessionData) {
        setUserSessionData(action.email, {});
      }
      return {
        ...state,
        sessionData: sessionData || {}
      };
    }
    case SET_USER_SESSION_DATA_BY_KEY: {
      let sessionData = {
        ...state.sessionData,
        [action.payload.key]: action.payload.value,
      };
      return {
        ...state,
        sessionData
      }
    }

    case FETCH_USER_ALLOWED_RIS_WITH_MIPS_SUCCESS: {
      let newAuthUser = { ...state.authUser };
      newAuthUser.risWithMips = action.risWithMips || [];
      sessionStorage.setItem("user", JSON.stringify(newAuthUser));
      return {
        ...state,
        authUser: { ...newAuthUser }
      };
    }

    case FETCH_USER_ALLOWED_RIS_WITH_MIPS_ERROR: {
      let newAuthUser = { ...state.authUser };
      newAuthUser.risWithMips = [];
      sessionStorage.setItem("user", JSON.stringify(newAuthUser));
      return {
        ...state,
        authUser: { ...newAuthUser }
      };
    }
    case UPDATE_USER_OTP_VERIFICATION: {
      newAuthUser = { ...state.authUser }
      newAuthUser.otpVerified = true;
      sessionStorage.setItem('user', JSON.stringify(newAuthUser));
      return {
        ...state,
        authUser: { ...newAuthUser }
      }
    }
    case UPDATE_USER_IS_AUTHENTICATOR: {
      newAuthUser = { ...state.authUser }
      newAuthUser.isAuthenticator = true;
      sessionStorage.setItem('user', JSON.stringify(newAuthUser));
      return {
        ...state,
        authUser: { ...newAuthUser }
      }
    }
    default:
      return state;
  }
}
